import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Rafraîchissement automatique : le jeton d'accès vit 1 h, le jeton de rafraîchissement 7 j.
// Sur un 401, on tente une régénération silencieuse puis on rejoue la requête.
const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/google"];
let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    if (error.response?.status === 401 && !original._retried && !NO_REFRESH.some((p) => url.includes(p))) {
      original._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(original);
      } catch {
        /* session expirée : l'utilisateur devra se reconnecter */
      }
    }
    return Promise.reject(error);
  }
);

export function fmtError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Une erreur est survenue. Réessayez.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export const trackCoverUrl = (t) => `${API}/tracks/${t.track_id}/cover`;
export const trackAudioUrl = (t) => `${API}/tracks/${t.track_id}/audio`;

export const eur = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n);

export const fmtTime = (s) => {
  if (!s || !isFinite(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${String(sec).padStart(2, "0")}`;
};
